import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiPartnerConsolesCompaniesAnalyticsDetailAnalysisIndexResponseType,
  ApiPartnerConsolesCompaniesAnalyticsDetailAnalysisIndexRequestType,
} from "~/domains";

type RequestDataType = {
  companyId: string;
  params?: ApiPartnerConsolesCompaniesAnalyticsDetailAnalysisIndexRequestType;
};

const request = async ({
  params,
  companyId,
}: RequestDataType): Promise<ApiPartnerConsolesCompaniesAnalyticsDetailAnalysisIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiPartnerConsolesCompaniesAnalyticsDetailAnalysisIndexResponseType>(
      `/api/partner_consoles/companies/${companyId}/analytics/detail_analysis`,
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiPartnerConsolesCompaniesAnalyticsDetailAnalysisIndexRequestType;
  companyId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisPartnerConsolesCompaniesAnalyticsDetailAnalysisIndex = ({
  params,
  companyId,
  config = {},
}: PropsType): UseQueryResult<ApiPartnerConsolesCompaniesAnalyticsDetailAnalysisIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      "ApisPartnerConsolesCompaniesAnalyticsDetailAnalysisIndex",
      companyId,
      params,
    ],
    queryFn: () => request({ companyId, params }),
  });
};
